import { useEffect, useRef } from 'react'
import {
  captureTrackingParams,
  getStoredTracking,
  trackFormStart,
  trackStepComplete,
  trackFormComplete,
  trackFormAbandon,
  type TrackingParams,
} from '../lib/tracking'

export function useTracking() {
  const hasStarted = useRef(false)
  const currentStep = useRef(0)

  // Capture tracking params on mount
  useEffect(() => {
    captureTrackingParams()
    
    // Track form start only once
    if (!hasStarted.current) {
      trackFormStart()
      hasStarted.current = true
    }

    // Track abandonment on page unload
    const handleUnload = () => {
      if (currentStep.current > 0 && currentStep.current < 7) {
        trackFormAbandon(currentStep.current)
      }
    }

    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
  }, [])

  const getTracking = (): TrackingParams => {
    return getStoredTracking()
  }

  const onStepComplete = (stepNumber: number, stepName: string, data?: Record<string, unknown>) => {
    currentStep.current = stepNumber
    trackStepComplete(stepNumber, stepName, data)
  }

  const onFormComplete = (leadId: string) => {
    currentStep.current = 7
    trackFormComplete(leadId)
  }

  return {
    getTracking,
    onStepComplete,
    onFormComplete,
  }
}
